// chakra imports
import {Flex, Icon, Text, useColorModeValue} from "@chakra-ui/react";
import {MdNotifications} from "react-icons/md";
import React from "react";

export function ItemContent(props) {
    const textColor = useColorModeValue("navy.700", "white");
    return (
        <>
            <Flex
                justify='center'
                align='center'
                borderRadius='16px'
                minH={{base: "45px", md: "50px"}}
                h={{base: "45px", md: "50px"}}
                minW={{base: "45px", md: "50px"}}
                w={{base: "45px", md: "50px"}}
                me='14px'
                bg='linear-gradient(135deg, #868CFF 0%, #4318FF 100%)'>
                <Icon as={MdNotifications} color='white' w={8} h={14}/>
            </Flex>
            <Flex flexDirection='column'>
                <Text
                    mb='5px'
                    fontWeight='bold'
                    color={textColor}
                    fontSize={{base: "md", md: "md"}}>
                    {props.info}
                </Text>
                <Flex alignItems='center'>
                    <Text
                        fontSize={{base: "sm", md: "sm"}}
                        lineHeight='100%'
                        color={textColor}>
                        Report Generated successfully.
                    </Text>
                </Flex>
            </Flex>
        </>
    );
}
